const authConfig = {
  domain: process.env.REACT_APP_AUTH_DOMAIN,
  clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
  redirectUri: `${window.location.origin}/callback`,
  responseType: 'token id_token',
  scope: 'openid profile email',
  cacheLocation: 'localstorage' as 'localstorage',
  useRefreshTokens: false 
};

export default authConfig;
